export default __webpack_public_path__ + "static/media/Dark Cloud.54171dd3.png";